function generateDefaultErrorMessage(error) {
  let errorMessage = `Error occured when requesting ${error?.config?.url || error?.config?.path}. Status code: ${error?.response?.status}`;
  if (error?.message) {
    errorMessage = `${errorMessage}. Details: ${error.message}`;
  }

  return errorMessage;
}

function resolvePromiseList(promise) {
  return promise.catch(function(result) {
    if (!process.env.BROWSER) {
      throw new Error(`Error occured on promise list. Details: ${result?.message}`);
    }
    return {result, isRejected: true}
  });
}

function resolveWithSettleContext(promise) {
  return promise.then(result => (
    {result, isResolved: true}
  )).catch(function(result) {
    const errorMessage = `${new Date().toISOString()} [ERROR] () {} ${generateDefaultErrorMessage(result)}`;
    if (!process.env.BROWSER) {
      console.log(errorMessage);
    }
    return {result, isRejected: true, hasError: true, statusCode: result?.response?.status, errorMessage: errorMessage}
  });
}

export {
  resolvePromiseList,
  resolveWithSettleContext,
};
